export const styles = {
    success: {
        background: '#3ec569',
        boxShadow: 'none'
    },
    error: {
        background: '#c44242',
        boxShadow: 'none'
    }
};
